import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine9 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#D2D200"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.54541 9.96833C7.54541 12.4594 9.31942 13.9124 11.4897 13.9124C12.9049 13.9124 13.7542 13.403 14.2071 13.0065C14.0372 15.6864 12.6597 17.0261 10.8291 17.0261C10.0742 17.0261 9.39495 16.8564 9.03642 16.7053L8.62125 18.9698C9.16861 19.1019 9.84789 19.1964 10.6027 19.1964C14.7922 19.1964 16.9248 16.0258 16.9248 11.4024C16.9248 7.87331 15.6412 5.36363 12.056 5.36363C9.31942 5.36363 7.54541 7.30733 7.54541 9.96833ZM10.2062 9.68534C10.2062 8.53397 10.8668 7.4584 12.1499 7.4584C13.4709 7.4584 14.188 8.6853 14.188 9.94945C14.188 10.346 14.188 10.8553 14.0369 11.0817C13.7728 11.4969 13.1124 11.8179 12.3009 11.8179C11.0176 11.8179 10.2062 10.9309 10.2062 9.68534Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine9);
export { ForwardRef as ReactComponent };
